export function moveElement<T>(
  array: T[],
  fromIndex: number,
  toIndex: number
): void {
  const removed = array.splice(fromIndex, 1);
  array.splice(toIndex, 0, removed[0]);
}
